import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ReactiveFormsModule} from "@angular/forms";
import {LangService} from '../../../../../services/language/lang.service';
import {LoaderService} from '../../../../../services/loader/loader.service';
import { NgOptimizedImage } from '@angular/common';
import {ConfirmDirective} from '../../../../../directives/confirm/confirm.directive';
import {IsGrantedDirective} from '../../../../../directives/is-granted/is-granted.directive';
import {IsGranted} from '../../../../../decorator/is-granted';
import {MetaTitle} from '../../../../../decorator/meta-title';
import {DialogService} from '../../../../../services/dialog/dialog.service';
import {LanguageFormComponent} from '../language-form/language-form.component';
import {Language} from '../../../../../models/language';
import {ClassSorter} from '../../../../../tools/class-sorter/class-sorter';

@Component({
  selector: 'app-language-list',
  imports: [
    ReactiveFormsModule,
    NgOptimizedImage,
    ConfirmDirective,
    IsGrantedDirective
],
  templateUrl: './language-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './language-list.component.scss'
})
@IsGranted(['LANGUAGE_VIEW'])
@MetaTitle('Languages')
export class LanguageListComponent implements OnInit {
  languages: Language[] = [];

  constructor(
    private loader: LoaderService,
    private dialogService: DialogService,
    protected langService: LangService
  ) {
  }

  ngOnInit(): void {
    this.fetchAll();
  }

  fetchAll(): void {
    this.loader.startLoading();
    this.langService.getLanguages().subscribe((languages) => {
      this.languages = languages;
      ClassSorter.sort(this.languages, 'name');
      this.loader.stopLoading();
    });
  }

  delete(language: Language): void {
    this.loader.startLoading();
    this.langService.delete(language).subscribe(() => {
      this.fetchAll();
    });
  }

  create(): void {
    this.dialogService.openDialog(LanguageFormComponent, {}).subscribe(() => {
      this.fetchAll();
    });
  }
}
